import React from "react";
import vector from '../Images/Vector3.png'



const Hero = () => {


    return(
        <>
        <div className="about">
            <div className="container">
                <div className="row top" style={{marginBottom: '20%'}}>
                     <h1 style={{fontWeight: '700', paddingTop: '30%', fontSize: '52px'}}>About<span style={{color: '#F29235',}}> Chilicom Technologies</span></h1>                       
                </div>     
            </div>
        </div>

        

        <div>
            <div className="container">
                <div className="row text-center mt-5 pb-5">
                        <img style={{width: '70px', background: 'white', padding: '10px', borderRadius: '10px'}} className="img-fluid mt-5 mx-auto d-block" src={vector} alt="" />
                        <h1 className="mt-4" style={{color: '#353995', fontWeight: '700'}}>Why We Exist</h1>
                        <p className="mt-3 pb-5">Chilicom was born to disrupt the cold, mechanical nature of enterprise <br /> technology. We bridge the gap betwen <span style={{color: '#353995'}}>complex data</span>  and <span style={{color: '#F29235'}}>human <br /> connection</span> , building tools that dont just work, they resonate</p>
                    </div>                
            </div>
  
        </div>
        </>
    )
}

export default Hero;